/**
 * Duration suffixes the observability search backend accepts on numeric duration
 * columns (`h`, `m`, `s`, `ms`, `us`, `ns`). Values are passed through as typed;
 * conversion to the column's base unit happens in the searchfilter listener.
 */

/** Partial suffixes allowed while typing (e.g. `5m` on the way to `5ms`). */
export const DURATION_VALUE_INPUT_RE = /^-?\d*\.?\d*(n|ns|u|us|m|ms|s|h)?$/i;

export function isDurationValueInput(value: string): boolean {
  return DURATION_VALUE_INPUT_RE.test(value);
}

/** Leaf names that GetKeys reports as Numeric but are duration columns. */
export function isDurationFieldName(field: string): boolean {
  const leaf = field.includes('.') ? field.slice(field.lastIndexOf('.') + 1) : field;
  return leaf === 'duration' || leaf.endsWith('_duration');
}
